import { showConfirm } from '../../components/BcConfirm'
import { FileApi } from '../../test-api/index.ts'
import Toast from '@/frontapp/mixins/actions/Toast'
import useBcFileStore from '@/frontapp/store/bcFile'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { $t } from 'nette-base-module/js/vuei18next'
import $mitt from '../../../frontapp/emitter'
import handleApiError from '../../utils/handleApiError'

const fileApi = new FileApi({}, '/api/v2')

const doRestoreFiles = async function (fileIds) {
    // delete
    await handleApiError(() => fileApi.fileMultipleRestoreFromTrash({ ids: fileIds }))
    
        // remove deleted files from list
    const bcFileStore = useBcFileStore()
    fileIds.forEach((id) => {
        bcFileStore.deleteFile(id)
    })
    
    Toast(
        'success',
        fileIds.length > 1 ? $t('%cnt% files were restored', { cnt: fileIds.length }) : $t('File was restored')
    )
    
    useBcSelectedStore().resetSelected()

    // triggers brandcloud global event bc-delete-file
    $mitt.emit('bc-delete-file', { fileIds: fileIds })
}

export default async function (fileIds) {
    const confirm = await showConfirm({
        header: $t(fileIds.length === 1 ? 'Do you want restore from trash selected file?' : 'Do you want restore from trash selected files?'),
    })

    if (!confirm) {
        return
    }

    return await doRestoreFiles(fileIds, null)
}
